import getDatesIntervalWithSubtractMinutes from '../../../localUtils/getDatesIntervalWithSubtractMinutes'

export default function getTwentyFourHoursAgo() {
  const twentyFourHoursAgo = 24 * 60

  const dates = getDatesIntervalWithSubtractMinutes(twentyFourHoursAgo)

  const options = {
    name: 'TWENTY_FOUR_HOURS_AGO',
    label: '24 horas',
    ...dates,
  }

  return options
}
